const ORDER_LEGACY_COMPATIBILITY_FIELDS = `
  orderId
  orderNumber
  orderStatus
  currency
  total
  paidAt
  scheduledPaymentDate
  reservationNumber
  paymentCondition
  requestedByName
  requestedByEmail
  createdAt
  updatedAt
  providerSnapshot {
    id
    name
  }
  fileSnapshot {
    fileNumber
    fileExtend
    clientName
  }
  lines {
    orderLineId
    serviceId
    ticketId
    amount
    serviceSnapshot {
      operationDate
      serviceType
      serviceCategory
    }
  }
`

export const GET_ORDER = `
  query GetOrder($orderId: ID!) {
    getOrder(orderId: $orderId) {
      ${ORDER_LEGACY_COMPATIBILITY_FIELDS}
    }
  }
`

export const GET_ORDERS_BY_PROVIDER = `
  query GetOrdersByProviderId($providerId: ID!) {
    getOrdersByProviderId(providerId: $providerId) {
      ${ORDER_LEGACY_COMPATIBILITY_FIELDS}
    }
  }
`

export const GET_ORDERS_AVAILABLE = `
  query GetOrdersAvailablePage($input: GetOrdersAvailableInput) {
    getOrdersAvailablePage(input: $input) {
      items {
        ${ORDER_LEGACY_COMPATIBILITY_FIELDS}
      }
      lastKey
    }
  }
`

export const GET_ORDERS_AVAILABLE_FOR_EGRESOS = `
  query GetOrdersAvailableForEgresosPage(
    $input: GetOrdersAvailableForEgresosInput
  ) {
    getOrdersAvailableForEgresosPage(input: $input) {
      items {
        orderId
        orderNumber
        orderStatus
        currency
        total
        paidAt
        scheduledPaymentDate
        paymentCondition
        providerSnapshot {
          id
          name
        }
        fileSnapshot {
          fileNumber
          fileExtend
        }
      }
      lastKey
    }
  }
`
